<template>
  <el-form-item :label="i18nt('designer.setting.labelWidth')">
    <el-input
      v-model="optionModel.labelWidth"
      type="number"
      min="0"
      class="hide-spin-button"
      @input.native="inputNumberHandler"
    />
  </el-form-item>
</template>

<script>
import i18n from '@/utils/i18n'
import propertyMixin from '@/components/form-designer/setting-panel/property-editor/propertyMixin'

/* eslint-disable */
export default {
  name: 'LabelWidthEditor',
  mixins: [i18n, propertyMixin],
  props: {
    designer: Object,
    selectedWidget: Object,
    optionModel: Object,
  },
}
</script>

<style scoped>

</style>
